import LOGO from "../images/PecanBros.png";

export const Team__PecanBros = {
  name: "Pecan Bros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#222222",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 32 + 38 + 28,
  goalsScoredAgainst: 27 + 28 + 24,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
